import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { createInventorySlice, InventorySlice } from './inventorySlice'
import { createShoppingSlice, ShoppingSlice } from './shoppingSlice'
import { createDealsSlice, DealsSlice } from './dealsSlice'
import { createTransactionsSlice, TransactionsSlice } from './transactionsSlice'
import { createSettingsSlice, SettingsSlice } from './settingsSlice'

export type AppState = InventorySlice &
  ShoppingSlice &
  DealsSlice &
  TransactionsSlice &
  SettingsSlice

export const useAppStore = create<AppState>()(
  persist(
    (...a) => ({
      ...createInventorySlice(...a),
      ...createShoppingSlice(...a),
      ...createDealsSlice(...a),
      ...createTransactionsSlice(...a),
      ...createSettingsSlice(...a),
    }),
    {
      name: 'bulkrr-storage-v2', // New storage key to avoid conflicts with legacy app
    },
  ),
)
